import hanHuang from './../assets/avatars/HanHuang.jpg';
import ShirongGe from './../assets/avatars/ShirongGe.jpg';
import lihongSu from './../assets/avatars/LihongSu.jpg';
import MingQiao from './../assets/avatars/MingQiao.jpg';
import muratKarakus from './../assets/avatars/MuratKarakus.jpg';
import TingRen from './../assets/avatars/TingRen.jpg';
import YoonJeongWhan from './../assets/avatars/YoonJeongWhan.jpg';
import ZhengyiJiang from './../assets/avatars/ZhengyiJiang.jpg';
import HelenJiang from './../assets/avatars/Helen.jpg';
import HalGurgenci from './../assets/avatars/HalGurgenci.jpg';
import SimonRoss from './../assets/avatars/SimonRoss.jpg';
import ValerieLinton from './../assets/avatars/ValerieLinton.jpg';
import XueqiuHe from './../assets/avatars/XueqiuHe.jpg';
import FanWang from './../assets/avatars/FanWang.jpg';
import QingxueHuang from './../assets/avatars/QingxueHuang.jpg';
import novotel from './../assets/avatars/novotel.jpg';
import totto from './../assets/avatars/totto.jpg';
import sage from './../assets/avatars/sage.jpg';
import quest from './../assets/avatars/quest.jpg';
import mantra from './../assets/avatars/mantra.jpg';
import Olivia from './../assets/avatars/OliviaMirza.jpg';
import Leszek from './../assets/avatars/Leszek.png';
import Liliang from './../assets/avatars/liliangwang.png';
import mingyang from './../assets/avatars/mingyang.png';
import kenich from './../assets/avatars/ken.jpg';
import malifeng from './../assets/avatars/malifeng.png';
import dou from './../assets/avatars/dou.jpg';
import weiming from './../assets/avatars/chen.jpg';
import xuesheng from './../assets/avatars/xuesheng.jpg';
import jianping from './../assets/avatars/jianping.jpeg';
import peter from './../assets/avatars/PeterKnights.jpg';
import vishnu from './../assets/avatars/VishnuPareek.jpg';
import jianqiang from './../assets/avatars/JianqiangZhang.jpg'
import alex from './../assets/avatars/AlexRemennikov.jpg';
import chaozhang from './../assets/avatars/ChaoZhang.jpg';
import richardyang from './../assets/avatars/RichardYang.jpg';
import yixia from './../assets/avatars/SarahZhang.jpg';
import davidhastie from './../assets/avatars/DavidHastie.jpg';
import jonroberts from './../assets/avatars/JonRoberts.jpg';
import guangqing from './../assets/avatars/GuangqingZhang.jpg';
import dipan from './../assets/avatars/Di.jpg';
import guangyao from './../assets/avatars/GuangyaoSi.jpg';
import mingyuan from './../assets/avatars/MingyuanLU.jpg';
import taowang from './../assets/avatars/taowang.jpg';
import jinweizhao from './../assets/avatars/jinweizhao.jpg';
import zouguoyi from './../assets/avatars/guoyizou.jpg';





export const unis = {
  unsw: {
    name: "University of New South Wales"
  },
  uoa: {
    name: "University of Adelaide"
  },
  uow: {
    name: "University of Wollongong"
  },
  uq: {
    name: "The University of Queensland"
  },
  wsu: {
    name: "Western Sydney University"
  },
  curtin: {
    name: "Curtin University"
  },
  deakinuni: {
    name: "Deakin University"
  },
}


export const advisoryCommittee = [
  {
    title: "Prof",
    avatar: QingxueHuang,
    name: "Qingxue Huang (Co-chair)",
    position: "Academician, Taiyuan University of Technology",
    url: "https://en.wikipedia.org/wiki/Huang_Qingxue"
  }, 
  {
    title: "Prof",
    avatar: ShirongGe,
    name: "Shirong Ge (Co-chair)",
    position: "Academician, Jiangxi University of Science and Technology",
    url: "https://www.cumtb.edu.cn/info/1012/1956.htm"
  },
  {
    title: "Prof",
    avatar: Olivia,
    name: "Olivia Mirza",
    position: "Western Sydney University",
    url: "https://www.westernsydney.edu.au/dvcresearch/dvc_research/research_theme_program/research_theme_champions/olivia_mirza"
  },
  {
    title: "Prof",
    avatar: Leszek,
    name: "Leszek Adam Dobrzanski",
    position: "Centre for Research, Design and Production ASKLEPIOS Ltd in Gliwice, Poland",
    url: "https://scholar.google.com/citations?user=hSDLvSQAAAAJ&hl=en"
  },
  {
    title: "Prof",
    avatar: Liliang,
    name: "Liliang Wang",
    position: "Imperial College, London UK",
    url: "https://profiles.imperial.ac.uk/liliang.wang"
  },
  {
    title: "Prof",
    avatar: mingyang,
    name: "Ming Yang",
    position: "Tokyo Metropolitan University",
    url: "https://researchmap.jp/Yang_Lab/research_experience/18312636?limit=90&lang=en"
  },
  {
    title: "Emeritus Prof",
    avatar: kenich,
    name: "Ken-Ichi Manabe",
    position: "Tokyo Metropolitan University",
    url: "https://researchmap.jp/read0019802/research_experience/27324975/?lang=en&limit=60"
  },
  {
    title: "Prof",
    avatar: malifeng,
    name: "Lifeng Ma",
    position: "Taiyuan University of Science and Technology",
    url: "https://www.researchgate.net/scientific-contributions/Ma-Lifeng-2103252243"
  },
  {
    name: "Linming Dou",
    title: "Prof",
    avatar: dou,
    position: "China University of Mining and Technology",
    url: "https://global.cumt.edu.cn/info/1193/1543.htm"
  },
  {
    name: "Weimin Cheng",
    title: "Prof",
    avatar: weiming,
    position: "Shandong University of Science and Technology",
    url: "https://www.researchgate.net/scientific-contributions/Weimin-Cheng-2052413902"
  },
  {
    name: "Sheng Xue",
    title: "Prof",
    avatar: xuesheng,
    position: "Anhui University of Science and Technology",
    url: "https://aqkxygc.aust.edu.cn/info/1368/6953.htm"
  },
  {
    name: "Jianping Wei",
    title: "Prof",
    avatar: jianping,
    position: "Henan Polytechnic University",
    url: "https://www.researchgate.net/scientific-contributions/Jianping-Wei-2153253297"
  },
  {
    title: "Prof",
    avatar: XueqiuHe,
    name: "Xueqiu He",
    position: "University of Science and Technology Beijing China",
    url: "https://www.icmsse.com/js/5996.pdf"
  }, 
]
  export const advisoryCommitteeChairMembers = [
    {
      title: "Prof",
      avatar: QingxueHuang,
      name: "Qingxue Huang",
      position: "Academician, Taiyuan University of Technology",
      url: "https://en.wikipedia.org/wiki/Huang_Qingxue"
    }, 
    {
      title: "Prof",
      avatar: ShirongGe,
      name: "Shirong Ge",
      position: "Academician, Jiangxi University of Science and Technology",
      url: "https://www.cumtb.edu.cn/info/1012/1956.htm"
    },
]


export const organisingCommittee = [
  {
    title: "Distinguished Prof",
    avatar: ZhengyiJiang,
    name: "Zhengyi Jiang (Chair)",
    position: "Director ARC Innovative Composites for Sustainable Mining, University of Wollongong",
    url: "https://scholars.uow.edu.au/zhengyi-jiang"
  }, 
  {
    title: "Prof",
    avatar: TingRen,
    name: "Ting Ren (Co-chair)",
    position: "Deputy Director ARC Innovative Composites for Sustainable Mining, University of Wollongong",
    url: "https://scholars.uow.edu.au/ting-ren"
  },
  {
    title: "Prof",
    avatar: hanHuang,
    name: "Han Huang",
    position: "Program Leader ARC Innovative Composites for Sustainable Mining, University of Queensland",
    url: "https://mechmining.uq.edu.au/profile/386/han-huang"
  }, 
  {
    title: "Prof",
    avatar: peter,
    name: "Peter Knights",
    position: "Program Leader ARC Innovative Composites for Sustainable Mining, University of Queensland",
    url: "https://about.uq.edu.au/experts/1475"
  },
  {
    title: "Prof",
    avatar: YoonJeongWhan,
    name: "Jeong Yoon",
    position: "Program Leader ARC Innovative Composites for Sustainable Mining, Deakin University",
    url: "https://www.deakin.edu.au/about-deakin/people/jeong-yoon"
  },
  {
    title: "A-Prof",
    avatar: muratKarakus,
    name: "Murat Karakus",
    position: "Program Leader ARC Innovative Composites for Sustainable Mining, University of Adelaide",
    url: "https://scholars.uow.edu.au/simon-moss"
  },   
  {
    title: "Distinguished Prof",
    avatar: vishnu,
    name: "Vishnu Pareek",
    position: "Curtin University",
    url: "https://staffportal.curtin.edu.au/staff/profile/view/vishnu-pareek-6b73f5f5/"
  },
  {
    title: "Prof",
    avatar: jianqiang,
    name: "Jianqiang Zhang",
    position: "University of New South Wales",
    url: "https://www.unsw.edu.au/staff/jianqiang-zhang"
  },
  {
    name: "Alex Remennikov",
    title: "Prof",
    avatar: alex,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/alex-remennikov"
  },
  {
    name: "Chao Zhang",
    title: "Prof",
    avatar: chaozhang,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/chao-zhang"
  },
  {
    name: "Richard Yang",
    title: "Prof",
    avatar: richardyang,
    position: "Western Sydney University",
    url: "https://www.westernsydney.edu.au/cfmat/people/professor_richard_yang"
  },
  {
    name: "Yixia Zhang",
    title: "Prof",
    avatar: yixia,
    position: "University of Technology Sydney",
    url: "https://profiles.uts.edu.au/Sarah.Zhang"
  },
  {
    title: "Prof",
    avatar: zouguoyi,
    name: "Gow-Yi Tzou",
    position: "Minghsin University of Science and Technology",
    url: "https://acade.must.edu.tw/member/page.aspx?UnitID=42&id=8403"
  },
  {
    name: "Lihong Su",
    title: "Dr",
    avatar: lihongSu,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/lihong-su"
  },
  {
    name: "David Hastie",
    title: "Dr",
    avatar: davidhastie,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/david-hastie"
  },
  {
    name: "Jon Roberts",
    title: "Dr",
    avatar: jonroberts,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/jon-roberts"
  },
  {
    name: "Guangqing Zhang",
    title: "Dr",
    avatar: guangqing,
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/guangqing-zhang"
  },
  {
    name: "Di Pan",
    title: "Dr",
    avatar: dipan,
    position: "University of Wollongong",
    url: ""
  },
  {
    title: "Dr",
    avatar: MingQiao,
    name: "Ming Qiao",
    position: "University of Wollongong",
    url: "https://scholars.uow.edu.au/ming-qiao"
  }, 
  {
    title: "Dr",
    avatar: guangyao,
    name: "Guangyao Si",
    position: "University of New South Wales",
    url: "https://research.unsw.edu.au/people/dr-guangyao-si"
  },
  {
    title: "Dr",
    avatar: mingyuan,
    name: "Mingyuan Lu",
    position: "University of Queensland",
    url: "https://about.uq.edu.au/experts/12274"
  }, 
  {
    title: "Prof",
    avatar: taowang,
    name: "Tao Wang",
    position: "Taiyuan University of Technology",
    url: "https://mc.tyut.edu.cn/info/1207/4775.htm"
  },
  {
    title: "Prof",
    avatar: jianping,
    name: "Cunlong Zhou",
    position: "Taiyuan University of Science and Technology",
    url: ""
  },
  {
    title: "Prof",
    avatar: jinweizhao,
    name: "Jinwei Zhao",
    position: "Taiyuan University of Technology",
    url: "https://mc.tyut.edu.cn/info/1207/4778.htm"
  },
]

export const hotel = [
  {
    title: "Novotel Wollongong Northbeach (One of the conference's location)",
    avatar: novotel,
    name: "2-14 Cliff Rd, North Wollongong, NSW 2520",
    position: "Phone: +(02) 4224 3111; Email: hl654@accor.com",
    price: "One Queen bed: $AUD 275 per night; Two beds: $AUD 319 per night",
    containing: "Coffee/tea maker; Fridge; Buffet breakfast (6:30 - 10:30 AM): AUD 42 for adults and AUD 19 for children",
    url: "novotelnorthbeach.com.au",
    Transport: "Transport to UOW [Free bus: Walk 200 meters and take the 55A/55C free bus.]"
  }, 
  {
    title: "Hotel TOTTO Wollongong",
    avatar: totto,
    name: "60 Market St, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 9069 5528; Email: reservations_hoteltotto@evt.com",
    price: "One Queen bed: $AUD 214 per night; Two beds: $AUD 241 per night",
    containing: "Coffee/tea maker; Minibar; Cooked-to-order breakfast (7:00 - 10:00 AM): AUD 25 for adults and AUD 15 for children",
    url: "https://www.hoteltotto.com/",
    Transport: "Transport to UOW [Free bus: Walk 350 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 350 meters and take the 55A free bus.]"
  }, 
  {
    title: "Sage Hotel Wollongong ",
    avatar: sage,
    name: "59-61 Kembla Street, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4201 2111; Email: reservations.wollongong@sage-hotels.com",
    price: "One Queen bed: $AUD 279 per night; Two beds: $AUD 279 per night",
    containing: "continental breakfast (6:30 - 9:30 AM): AUD 20-40 for adults and AUD 12.5-20 for children",
    url: "https://www.nexthotels.com/sage/wollongong/",
    Transport: "Transport to UOW [Free bus: Walk 550 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 550 meters and take the 55A free bus.]"
  }, 
  {
    title: "Quest Wollongong",
    avatar: quest,
    name: "60-62 Harbour Street, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4221 1500",
    price: "One Queen bed: $AUD 249 per night; Three beds(1 king bed and 2 single beds): $AUD 329 per night",
    containing: "Coffee/tea maker; Full sized fridge; Cookware/dishes/utensils; Dining area; Dishwasher",
    url: "https://www.questapartments.com.au/properties/nsw/wollongong/quest-wollongong",
    Transport: "Transport to UOW [Free bus: Walk 400 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 400 meters and take the 55A free bus.]"
  }, 
  {
    title: "Mantra Wollongong",
    avatar: mantra,
    name: "6-10 Gladstone Ave, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4222 4000; Email: info@wollongonghotelapartments.com.au",
    price: "One Queen bed: $AUD 299 per night; Two beds: $AUD 383 per night",
    containing: "Coffee/tea maker; Full sized fridge; Cookware/dishes/utensils; Dining area; Dishwasher",
    url: "https://mhwollongong.com.au/",
    Transport: "Transport to UOW [Free bus: Walk 150 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 150 meters and take the 55A free bus.]"
  }, 
]
